import { StrictLocalizeFunction } from "@faire/web/common/localization";

import { IBreadcrumbOption } from "@faire/retailer/components/Breadcrumb";
import { ILeanBrandTileWithReview } from "@faire/retailer/components/LeanBrandTileRenderer/ILeanBrandTileWithReview";
import { getAllBrandsLink } from "@faire/retailer/consts/allBrandsLinks";
import { Category } from "@faire/retailer/models/Category/Category";
import { IUrlId } from "@faire/retailer/models/Category/IUrlId";
import { categoryPath } from "@faire/retailer/paths/category/categoryPath";
import { getCategoryDisplayName } from "@faire/retailer/services/Categories";

const IDEAL_REVIW_LENGTH = 160;
export const getMetaDescription = (
  brandReviews: ILeanBrandTileWithReview[] | undefined,
  baseDescription: string | undefined
) => {
  const brandReviewTile = brandReviews?.sort(reviewSort)[0];
  if (brandReviewTile?.review?.review_comment !== undefined) {
    return brandReviewTile.review.review_comment;
  } else {
    return baseDescription;
  }
};

const reviewSort = (
  a: ILeanBrandTileWithReview,
  b: ILeanBrandTileWithReview
) => {
  const lengthDifference =
    Math.abs(
      (a.review?.review_comment?.length ?? Number.MAX_VALUE) -
        IDEAL_REVIW_LENGTH
    ) -
    Math.abs(
      (b.review?.review_comment?.length ?? Number.MAX_VALUE) -
        IDEAL_REVIW_LENGTH
    );

  if (lengthDifference === 0) {
    return (b.review?.average_rating ?? 0) - (a.review?.average_rating ?? 0);
  } else {
    return lengthDifference;
  }
};
export const getCategoryBreadcrumbOptions = (
  category: Category,
  strictLocalize: StrictLocalizeFunction,
  selectedFilterName?: string | undefined
) => {
  const breadCrumbOptions: IBreadcrumbOption[] = getBreadCrumb(
    category,
    [category.urlId],
    [],
    strictLocalize
  );
  if (selectedFilterName) {
    breadCrumbOptions.push({
      label: selectedFilterName,
      path: undefined,
    });
  }

  // last breadcrumb should not have a path
  const lastBreadcrumbOption = breadCrumbOptions[breadCrumbOptions.length - 1];
  if (lastBreadcrumbOption) {
    lastBreadcrumbOption.path = undefined;
  }

  return breadCrumbOptions;
};

const getBreadCrumb = (
  category: Category,
  categoryUrlIds: [...IUrlId[], IUrlId],
  breadCrumbOptions: IBreadcrumbOption[],
  strictLocalize: StrictLocalizeFunction
): IBreadcrumbOption[] => {
  const path =
    category.isNewProductsC1 || category.isAllBrands
      ? getAllBrandsLink()
      : categoryPath({
          urlIds: categoryUrlIds,
        });
  breadCrumbOptions.push({
    label: getCategoryDisplayName(category.name, strictLocalize),
    path,
  });
  if (category.subCategory) {
    return getBreadCrumb(
      category.subCategory,
      [...categoryUrlIds, category.subCategory.urlId],
      breadCrumbOptions,
      strictLocalize
    );
  }
  return breadCrumbOptions;
};
